import React, { Component } from 'react';
import AppSidebar from "../components/AppSidebar";
import PageHeader from "../components/PageHeader";
import ActionButton from "../components/ActionButton";
import PanelGroupController from "../components/PanelGroupController";
import UserPropertiesPanel from "./panels/UserPropertiesPanel";
import UsersList from "./views/UsersList";
import {List} from "immutable";
import "./UsersPage.css";

class UsersPage extends Component {

  constructor(props) {
    super(props);
    this.handleSetSelection = this.handleSetSelection.bind(this);
    this.state = {
      userId: "",
      hasUserSelection: false,
    }
  }


  render() {
    const page = this.props.route.page;
    let view = this.renderView(page);
    let panels = this.renderPanels(page);

    return (
      <div className="UsersPage SecurePage">
        <AppSidebar />
        <PageHeader title="Users" />
        <div className="PageContainer">
          {view}
        </div>
        <div className="PanelContainer">
          <div className="header" />
          {panels}
          <PanelGroupController title="Actions">
            <ActionButton 
              label="Setup New User" 
              show={page === "users"}
              active={false}
              onClick={this.handleSetupNewUser.bind(this)} />
          </PanelGroupController>

        </div>
      </div>
    );
  }

  renderView(page) {
    switch(page) {
      case "users":
        return (
          <UsersList 
            selectedUserId={this.state.userId} 
            onSelectionChange={this.handleSetSelection}
            />
        )
      default: 
        return <p>No view found</p>
    }
  }


  renderPanels(page) {
    switch(page) {
      case "users":
        return this.buildPanels(List([UserPropertiesPanel]));
      default:
        return null;
    }
  }

  buildPanels(panels) {
    return panels.map((x, i) => this.buildPanel(x, i));
  }

  buildPanel(component, index) {
    switch(component) {
      case UserPropertiesPanel:
        return <UserPropertiesPanel
                key={index}
                expanded={true}
                userId={this.state.userId}
                hasSelection={this.state.hasUserSelection}
                />
      default:
        return null;      
    }
  }

  handleSetSelection(id) {
    this.setState({userId: id, hasUserSelection: true});
  }

  handleSetupNewUser() {
    // this.props.requestCreateCustomer();
  }

}

export default UsersPage;
